import { render, staticRenderFns } from "./PodrucjaTema.vue?vue&type=template&id=94d95a66&scoped=true&"
import script from "./PodrucjaTema.vue?vue&type=script&lang=js&"
export * from "./PodrucjaTema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d95a66",
  null
  
)

export default component.exports